'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import type { Locale } from '~/i18n/i18n-config';
import { api } from '~/libs/api';
interface EmailTripArgs {
  email: string;
  marketingOptOut?: boolean;
  tripLink: string;
  tripTitle: string;
  captcha: string;
}
export function useEmailTrip() {
  const $ = _c(8);
  const mutation = api.automation.emailTrip.useMutation();
  const locale = useLocale() as Locale;
  let t0;
  if ($[0] !== locale || $[1] !== mutation) {
    t0 = args => mutation.mutateAsync({
      ...args,
      locale
    });
    $[0] = locale;
    $[1] = mutation;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const submit = t0;
  let t1;
  if ($[3] !== mutation.isError || $[4] !== mutation.isLoading || $[5] !== mutation.reset || $[6] !== submit) {
    t1 = {
      submit,
      isLoading: mutation.isLoading,
      isError: mutation.isError,
      reset: mutation.reset
    };
    $[3] = mutation.isError;
    $[4] = mutation.isLoading;
    $[5] = mutation.reset;
    $[6] = submit;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}